import { render, staticRenderFns } from "./Play_Worth.vue?vue&type=template&id=506bf457&scoped=true"
import script from "./Play_Worth.vue?vue&type=script&lang=js"
export * from "./Play_Worth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bf457",
  null
  
)

export default component.exports